export default function Logo() {
    return (
        <div className="py-0.5">
            <span className="text-xl font-bold text-[#2563eb] tracking-tight italic">Twachanga</span>
            {/* <div className="text-gray-400 text-sm font-semibold mt-1">Your dashboard</div> */}
        </div>
    )
}